import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColumnListComponent } from './column-list.component';
import { ColumnChooserComponent } from './column-chooser.component';
import { ColumnMenuChooserComponent } from './column-menu-chooser.component';
import { ColumnMenuFilterComponent } from './column-menu-filter.component';
import { ColumnMenuItemComponent } from './column-menu-item.component';
import { ColumnMenuItemContentTemplateDirective } from './column-menu-item-content-template.directive';
import { ColumnMenuSortComponent } from './column-menu-sort.component';
import { ColumnMenuComponent } from './column-menu.component';
import { ColumnMenuLockComponent } from './column-menu-lock.component';
import { FilterMenuModule } from '../filtering/menu/filter-menu.module';
import { ColumnMenuTemplateDirective } from './column-menu-template.directive';
var COMPONENTS = [
    ColumnListComponent,
    ColumnChooserComponent,
    ColumnMenuChooserComponent,
    ColumnMenuFilterComponent,
    ColumnMenuItemComponent,
    ColumnMenuItemContentTemplateDirective,
    ColumnMenuSortComponent,
    ColumnMenuComponent,
    ColumnMenuLockComponent,
    ColumnMenuTemplateDirective
];
/**
 * @hidden
 */
var ColumnMenuModule = /** @class */ (function () {
    function ColumnMenuModule() {
    }
    ColumnMenuModule.exports = function () {
        return [
            ColumnChooserComponent,
            ColumnMenuFilterComponent,
            ColumnMenuItemComponent,
            ColumnMenuItemContentTemplateDirective,
            ColumnMenuSortComponent,
            ColumnMenuLockComponent,
            ColumnMenuChooserComponent,
            ColumnMenuTemplateDirective
        ];
    };
    ColumnMenuModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [COMPONENTS],
                    imports: [CommonModule, FilterMenuModule],
                    exports: [COMPONENTS]
                },] },
    ];
    /** @nocollapse */
    ColumnMenuModule.ctorParameters = function () { return []; };
    return ColumnMenuModule;
}());
export { ColumnMenuModule };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/column-menu/column-menu.module.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/column-menu/column-menu.module.js
// module chunks = vendor